export default [
  {
    path: '/press',
    name: 'press',
    meta: {
      needsAuth: true
    },
    component: () => import(/* webpackChunkName: "press" */ '../views/Index.vue')
  },
  {
    path: '/press/edit/:id?',
    name: 'press-edit',
    meta: {
      needsAuth: true
    },
    component: () => import(/* webpackChunkName: "press-edit" */ '../views/Edit.vue')
  }
]
